import { render } from "./QuoteViewer.vue?vue&type=template&id=46f84263&ts=true"
import script from "./QuoteViewer.vue?vue&type=script&lang=ts"
export * from "./QuoteViewer.vue?vue&type=script&lang=ts"

import "./QuoteViewer.vue?vue&type=style&index=0&id=46f84263&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__